import React from 'react'
import PropTypes from 'prop-types'




const List = props => {
  const { data } = props
  return (
    <div className={'list'}>
      {data.map((i) => <a href={"/images/" + i }><img src={"/images/thumbnail/" + i } alt="" /></a>)}
    </div>
  )
}

List.propTypes = {

}

export default List